<template>
    <div class="printSets">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-row :gutter="120">
				<el-col :span="4"><div class="seize"></div></el-col>
                <el-col :span="20">
                    <el-form-item label="页眉内容" prop='printTopContent'>
                        <el-input v-model="form.printTopContent" placeholder="门店名称" style="width:300px"></el-input><span class="title">{{form.brandId == 1 ? '婷美摩力21产后恢复' : (form.brandId == 2 ? '臻幼堂小儿推拿' : (form.brandId == 3 ? '槑博士婴幼儿草本浴':''))}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="120">
				<el-col :span="4"><div class="seize"></div></el-col>
                <el-col :span="20">
                    <el-form-item label="页脚内容" prop='printBottomContent'>
                        <el-input type="textarea" v-model="form.printBottomContent" style="width:300px;height:140px;" placeholder="请输入页脚内容" resize="none"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
			<el-row :gutter="120">
				<el-col :span="4"><div class="seize"></div></el-col>
                <el-col :span="20">
                    <el-form-item label="打印尺寸" prop='printSize'>
                        <el-select v-model="form.printSize" placeholder="请选择打印尺寸" style="width:300px">
                            <el-option label="58mm打印机" value="58"></el-option>
                            <el-option label="80mm打印机" value="80"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="120">
				<el-col :span="4"><div class="seize"></div></el-col>
				<el-col :span="20">
					<div class="btnOptions">
						<el-button class="darkBtn" @click="printTest">打印测试</el-button>
						<el-button class="redBtn" @click="onSubmit">提交</el-button>
					</div>
				</el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import {storeInfo, updateStore} from '@/api'

export default {
  data() {
    return {
      form: {
        printTopContent: "",
        printBottomContent: "",
        printSize: "58"
      },
      rules: {
        printTopContent:[
          { required: true, message: "请输入页眉内容", trigger: "blur" },
          {
            min: 0,
            max: 30,
            message: "最多 30 个字符",
            trigger: "blur"
          }
        ],
        printBottomContent:[
          { required: true, message: "请输入页脚内容", trigger: "blur" },
          {
            min: 0,
            max: 200,
            message: "最多 200 个字符",
            trigger: "blur"
          }
        ],
        printSize: [
          { required: true, message: "请选择打印尺寸", trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.detailInfo();
  },
  methods: {
    detailInfo() {
      // 小票信息
      storeInfo().then(res => {
        if (res.code == 1) {
          this.form = res.data;
          this.form.printTopContent = res.data.brandId == 1 ? (res.data.printTopContent?res.data.printTopContent.split('婷美摩力21')[0]:'') : (res.data.brandId == 2 ? (res.data.printTopContent?res.data.printTopContent.split('臻幼堂')[0]:'') : (res.data.printTopContent?res.data.printTopContent.split('槑博士婴幼儿草本浴')[0]:''));
          if(!res.data.printBottomContent || res.data.printBottomContent == ''){
            this.form.printBottomContent = '温馨提示：请核对小票信息是否准确，若有疑问请与前台联系';//默认内容
          }
        }
      });
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          updateStore({
            operateFlag:'2',
            printTopContent:this.form.printTopContent + (this.form.brandId == 1 ? '婷美摩力21产后恢复' : (this.form.brandId == 2 ? '臻幼堂小儿推拿' : '槑博士婴幼儿草本浴')),
            printBottomContent:this.form.printBottomContent ? this.form.printBottomContent : '温馨提示：请核对小票信息是否准确，若有疑问请与前台联系',
            printSize:this.form.printSize
          }).then(res=>{
            this.detailInfo();
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    printTest() {
      // 打印测试
      var printHtml = "测试";
      var wind = window.open(
        "",
        "newwindow",
        "height=800, width=1200, top=0, left=200, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no"
      );
      wind.document.body.innerHTML = printHtml;
      wind.print();
    }
  }
};
</script>
<style lang="less" scoped>
.printSets {
  width: 100%;
  overflow: hidden;
  padding: 100px 50px 70px;
  .seize {
    height: 20px;
  }
  .title{
	  color: #666;
	  padding-left: 5px;
  }
}
</style>
<style lang="less">
.printSets .btnOptions {
  margin:40px 0 0 120px;
  .el-button {
    width: 135px;
    height: 46px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/printTicket.vue